module.exports = __webpack_public_path__ + "img/URY.98db13c5.svg";